import { feedback } from "./feedback.js";
import { privacy } from "./privacy.js";
import { refund } from "./refund.js";
import { terms } from "./terms.js";

export const LEGAL_DOCUMENTS = [terms, privacy, refund, feedback];

export const getLegalDocument = (id) => LEGAL_DOCUMENTS.find((doc) => doc.id === id);

// Page labels only, never legal wording.
export const LEGAL_UI_TEXT = {
  ar: {
    documents: "المستندات القانونية",
    contents: "المحتويات",
    backToTop: "العودة إلى الأعلى",
  },
  en: {
    documents: "Legal documents",
    contents: "Contents",
    backToTop: "Back to top",
    // The source documents are Arabic only. Remove this line once the translation is legally approved.
    translationNotice: "This English text is a translation of the Arabic document and is pending legal review.",
  },
};
